<template>
  <div>
    <LargeNotice
      v-if="error && error.type === 'TOKEN_EXPIRED'"
      icon="😢"
      :title="this.$t('error.title')"
      :subtitle="this.$t('error.expired-token')"
    />
    <LargeNotice v-else icon="😢" :title="this.$t('error.title')" :subtitle="this.$t('error.unknown-error')" />
  </div>
</template>

<script>
import LargeNotice from '@/components/notice/LargeNotice';

export default {
  name: 'BaseError',
  components: {
    LargeNotice,
  },
  props: {
    error: Object,
  },
};
</script>

<style lang="scss"></style>
